export const productRoutes = {
  'route.products.index': '/products',
  'route.products.show': '/products/[slug]',
  'route.products.category': '/products/categories/[slug]',
  'route.products.checkout': '/products/checkout',

  'api.products.item': 'shop/product/[id]',
  'api.products.datatable': 'shop/products',
  'api.products.filter-lists': 'shop/product/filter-lists',
  'api.products.category-item': 'categories/[slug]',
  'api.products.comments': 'shop/product/[id]/comment',
  'api.products.comment-list': 'shop/product/[id]/comments',
};
